import { useState } from 'react';
import { Form, FormGroup, Input, Button, Alert } from 'reactstrap';
import { ContactWrapper } from './Contact.styled';
import emailjs from "emailjs-com";

function Contact() {
   const [alert, setAlert] = useState({
      show: false,
      message: "",
      color: ""
   });

   const sendEmail = (e: any) => {
      e.preventDefault();

      emailjs.sendForm(
         "service_lr9m7pc",
         "template_nb0tpcu",
         e.target,
         "tZaypr-Nats3607Dk"
      ).then(
         () => {
            setAlert({
               show: true,
               message: "Message sent successfully!",
               color: "success"
            });
         },
         () => {
            setAlert({
               show: true,
               message: "Failed to send message.",
               color: "danger"
            });
         }
      );
   }

   return (
      <ContactWrapper>
         <h2 className="text-align-left">Contact</h2>
         <br />
         {alert.show && (
            <Alert color={alert.color} toggle={() => setAlert({ ...alert, show: false })}>
               {alert.message}
            </Alert>
         )}
         <p className="text-align-left">For any queries or concerns, please reach out to us. We are always ready to help you. To contact us, fill the below form with details and submit.</p>
         <Form className="text-align-left" onSubmit={sendEmail}>
            <FormGroup>
               <Input id="name" name="name" placeholder="Name" type="text" required />
            </FormGroup>
            <FormGroup>
               <Input id="email" name="email" placeholder="Email" type="email" required />
            </FormGroup>
            <FormGroup>
               <Input id="message" name="message" placeholder="Message" type="textarea" />
            </FormGroup>
            <br />
            <Button style={{ backgroundColor: '#647f19', borderColor: '#647f19' }} type="submit">Contact Us</Button>
         </Form>
         <br />
      </ContactWrapper>
   )
};

export default Contact;
